import React from "react"
import ReactDOM from "react-dom"
import * as Sentry from "@sentry/react"
import { Provider, useDispatch, useSelector } from "react-redux"
import App from "./App"
import ErrorBoundary from "./ErrorBoundary"
import configureStore from "./redux/store"
import axios from "axios"
import storageHelper from "./helpers/storageHelper"
import { PROD_URL } from "./common/constants"
import { AppState } from "./global"
import { isCordovaAvailable } from "./helpers/platform"
import * as serviceWorker from "./serviceWorker"

const sentryDsn = process.env.REACT_APP_SENTRY_DSN ?? ""

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT ?? "development",
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? "0"),
  })
}

const initialState: AppState = {
  profile: undefined,
  appVersion: "",
  isLoggedIn: false,
  loginErrorMessage: "",
  networkErrorMessage: "",
  documents: [],
  nextPageUrl: "",
  lastPageUrl: "",
  isLoading: false,
  isLoadingInfiniteScroll: false,
  employees: [],
  employee: null,
  departments: [],
  department: null,
}

export const store = configureStore(initialState)

console.log("BE", localStorage.getItem("beUrl"))

// PWA/Docker: se REACT_APP_API_BASE_URL xe vuoto, Axios usa lo stesso origin.
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL ?? PROD_URL
document.documentElement.style.setProperty("color", "--ion-color-primary")

const accessToken = storageHelper.getAccessToken()
if (accessToken && accessToken !== "") {
  axios.defaults.headers.common["Authorization"] = `JWT ${accessToken}`
}

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Provider>,
  document.getElementById("root")
)

if (isCordovaAvailable()) {
  // Nella shell iOS/Android il service worker PWA rischia de servir bundle veci nella WebView.
  serviceWorker.unregister()
} else {
  let refreshing = false
  navigator.serviceWorker?.addEventListener("controllerchange", () => {
    if (refreshing) {
      return
    }
    refreshing = true
    // Quando arriva una build nuova, ricarichiamo subito invece di lasciare bundle veci in giro.
    window.location.reload()
  })

  serviceWorker.register({
    onUpdate: (registration) => {
      registration.waiting?.postMessage({ type: "SKIP_WAITING" })
    },
  })
}
